// extracted by mini-css-extract-plugin
module.exports = {"coverSticker":"DraftSticker_coverSticker__N_0L8","coverSticker_draft":"DraftSticker_coverSticker_draft__dKRyL"};